<h2 mat-dialog-title class="av-section-title">
  {{ 'backoffice.users.dialogs.change_root.title' | translate }}
</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">
    {{
      'backoffice.users.dialogs.change_root.summary'
        | translate
          : {
              user: data.userName,
              email: data.userEmail,
              organization: data.organizationName,
            }
    }}
  </p>

  <p class="av-meta m-0">{{ 'backoffice.users.root.eligibility_rule' | translate }}</p>

  @if (overrideRequired()) {
    <div class="av-banner p-3 d-flex align-items-start gap-2">
      <mat-icon aria-hidden="true">warning</mat-icon>

      <div class="d-flex flex-column gap-2">
        <span>{{ 'backoffice.users.dialogs.change_root.no_role_warning' | translate }}</span>
        <span class="av-meta">{{ 'backoffice.users.root.override_rule' | translate }}</span>

        @if (overrideBlocked()) {
          <span class="av-meta">
            {{ 'backoffice.users.dialogs.change_root.override_blocked' | translate }}
          </span>
        }
      </div>
    </div>

    <form [formGroup]="formGroup">
      <label class="d-flex align-items-center gap-2">
        <input
          type="checkbox"
          formControlName="override"
          [disabled]="overrideBlocked()"
          (change)="toggleOverride($any($event.target).checked)"
        />
        <span class="av-section-hint">
          {{ 'backoffice.users.dialogs.change_root.override_checkbox' | translate }}
        </span>
      </label>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="cancel()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!canConfirm()"
    (click)="confirm()"
  >
    {{ 'backoffice.users.dialogs.change_root.confirm' | translate }}
  </button>
</mat-dialog-actions>
